<template>
  <main>
    <NodePressRelease v-if="node" v-bind="node" />
  </main>
</template>

<script setup lang="ts">
definePageMeta({
  path: '/medienmitteilungen/:slug(.*)',
})
const { entity: node } = await useDrupalRouteQuery('press_release')

await renderPageDependencies()
</script>
